'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2017/6/22.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlipayModal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(AlipayModal, _Component);

  function AlipayModal() {
    (0, _classCallCheck3.default)(this, AlipayModal);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(AlipayModal).call(this));
  }

  (0, _createClass3.default)(AlipayModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // this.currentSocket = this.initSocket();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // this.currentSocket.close();
    }
  }, {
    key: 'initSocket',
    value: function initSocket() {
      var _this2 = this;

      var _props = this.props;
      var user = _props.user;
      var data = _props.data;

      var socket = void 0;
      if ('WebSocket' in window) {
        if (user && user.userId && user.userId.split(',').length === 2) {
          console.log('WebSocket is supported by your browser.');

          // const serviceUrl = 'ws://115.182.102.130:1001'; 115.182.244.194
          var serviceUrl = 'ws://ty.goeasy.cn:1001';
          // const protocol = 'chat';
          socket = new WebSocket(serviceUrl);

          socket.onopen = function () {
            console.log('Connection Established!' + data.orderNumber);
            socket.send('{<' + data.orderNumber + '>}');
          };

          socket.onclose = function () {
            console.log('Connection Closed!');
          };

          socket.onerror = function (error) {
            console.log('Error Occured: ' + error);
          };

          socket.onmessage = function (event) {
            if (typeof event.data === 'string') {
              _this2.handleMessage(event.data);
            } else if (event.data instanceof ArrayBuffer) {
              console.log('ArrayBuffer received: ' + event.data);
            } else if (event.data instanceof Blob) {
              console.log('Blob received: ' + event.data);
            }
          };
        }
      }
      return socket;
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage(message) {
      var data = this.props.data;

      console.log(message);
      var result = void 0;
      var index = message.indexOf('{');
      if (index >= 0) {
        result = message.substr(index);
      }
      try {
        if (result && result !== '') {
          var info = JSON.parse(result);
          if (info.type === 'paymentInfo' && info.orderNumber === data.orderNumber) {
            if (info.success === 'true') {
              this.btnClick();
            } else {
              this.setState({ errorFromSocket: info.error });
            }
          }
        }
      } catch (ex) {
        console.log(ex.message);
      }
    }
  }, {
    key: 'btnClick',
    value: function btnClick(btn) {
      var onBtnClick = this.props.onBtnClick;

      if (onBtnClick) {
        onBtnClick(btn);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./AlipayModal.scss');
      var isOpened = this.props.isOpened;

      var customStyle = {
        content: {
          background: '#ffffff',
          overflow: 'hidden',
          outline: 'none',
          zIndex: 9999,
          border: '0',
          borderRadius: '30px',
          boxShadow: '3px 2px 20px',
          bottom: 'auto',
          minHeight: '10rem',
          left: '50%',
          padding: '2rem',
          position: 'fixed',
          right: 'auto',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          minWidth: '20rem',
          width: '400px',
          maxWidth: '60rem'
        }
      };
      return _react2.default.createElement(
        _reactModal2.default,
        { style: customStyle, isOpen: isOpened },
        _react2.default.createElement(
          'div',
          { className: styles.title },
          '订单支付中'
        ),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'h1',
            null,
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null),
            _react2.default.createElement('span', null)
          ),
          _react2.default.createElement(
            'div',
            { className: styles.text },
            '支付完成前请不要关闭此验证窗口'
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.attention },
            '如支付窗口被拦截,需浏览器设置取消拦截，',
            _react2.default.createElement(
              'a',
              {
                href: 'http://tupian.goeasy.cn:9999/yipinwang/%e5%a6%82%e4%bd%95%e5%8f%96%e6%b6%88%e6%b5%8f%e8%a7%88%e5%99%a8%e6%8b%a6%e6%88%aa%e6%94%af%e4%bb%98%e5%ae%9d.pdf',
                target: '_blank' },
              '查看设置方法'
            )
          ),
          _react2.default.createElement(_SubmitBtn2.default, { btnClick: function btnClick() {
              return _this3.btnClick('success');
            }, text: '支付成功' }),
          _react2.default.createElement(_SubmitBtn2.default, { btnClick: function btnClick() {
              return _this3.btnClick('back');
            }, text: '支付遇到问题' })
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return AlipayModal;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object,
  onBtnClick: _react.PropTypes.func,
  isOpened: _react.PropTypes.bool,
  user: _react.PropTypes.object
}, _temp);
exports.default = AlipayModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AlipayModal/AlipayModal.js
 ** module id = 1308
 ** module chunks = 0
 **/